import { render, staticRenderFns } from "./MediaAndDocumentSVG.vue?vue&type=template&id=098e3399"
import script from "./MediaAndDocumentSVG.vue?vue&type=script&lang=js"
export * from "./MediaAndDocumentSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports